const uploadSizeLimitInMB = 5;

export default {
  uploadSizeLimitInMB,
};
